import { SyntheticEvent, useCallback } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import PdfPanel from '../../Snapshot/ComparePdfsModal/PdfPanel';
import styles from '../styles';
import { ComparePdfViewMode } from '../utils';

const compareModalStyles = styles.compareModal;

/* eslint-disable no-unused-vars */
type SnapshotComparisonCompareModalProps = {
  open: boolean;
  onClose: () => void;
  applicationNumber: string;
  comparedToSubmission: string | null;
  currentSubmission: string | null;
  previousPdfUrl: string;
  previousPdfLoading: boolean;
  previousPdfError: string;
  currentPdfUrl: string;
  currentPdfLoading: boolean;
  currentPdfError: string;
  pdfViewMode: ComparePdfViewMode;
  onPdfViewModeChange: (mode: ComparePdfViewMode) => void;
};
/* eslint-enable no-unused-vars */

const SnapshotComparisonCompareModal = ({
  open,
  onClose,
  applicationNumber,
  comparedToSubmission,
  currentSubmission,
  previousPdfUrl,
  previousPdfLoading,
  previousPdfError,
  currentPdfUrl,
  currentPdfLoading,
  currentPdfError,
  pdfViewMode,
  onPdfViewModeChange
}: SnapshotComparisonCompareModalProps) => {
  const handleTabsChange = useCallback(
    (_: SyntheticEvent, value: string | number | null) => {
      if (value != null) {
        onPdfViewModeChange(value as ComparePdfViewMode);
      }
    },
    [onPdfViewModeChange]
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      PaperProps={{ sx: compareModalStyles.dialogPaper }}>
      <Box sx={compareModalStyles.root}>
        <Box sx={compareModalStyles.tabsBar}>
          <Tabs
            value={pdfViewMode}
            onChange={handleTabsChange}
            variant='fullWidth'
            sx={compareModalStyles.tabs}>
            <Tab value='clinical_studies' label='Clinical Studies (Section 14)' />
            <Tab value='adverse_reactions' label='Adverse Reactions (Section 6.1)' />
            <Tab value='full_label' label='Full Label' />
          </Tabs>
        </Box>

        <Box sx={compareModalStyles.content}>
          <Box sx={compareModalStyles.panelsContainer}>
            <Stack direction='row' spacing={0} sx={compareModalStyles.panelsStack}>
              <PdfPanel
                title={`Previous — ${applicationNumber}-${comparedToSubmission ?? ''}`}
                pdfUrl={previousPdfUrl}
                isLoading={previousPdfLoading}
                iframeTitle='Previous submission label'
                error={previousPdfError}
                emptyMessage='No previous label loaded'
                hideHeader
              />
              <PdfPanel
                title={`Current — ${applicationNumber}-${currentSubmission ?? ''}`}
                pdfUrl={currentPdfUrl}
                isLoading={currentPdfLoading}
                iframeTitle='Current submission label'
                error={currentPdfError}
                emptyMessage='No current label loaded'
                hideHeader
              />
            </Stack>
          </Box>
        </Box>

        <Box sx={compareModalStyles.footer}>
          <Button onClick={onClose} variant='contained' size='small'>
            Close
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default SnapshotComparisonCompareModal;
